import { GroupTransfer } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const GroupTransferPage = ({ isCopy, isEdit }: IOperationPageProps) => (
  <GroupTransfer isCopy={isCopy} isEdit={isEdit}/>
);
